exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.card[data-v-5cf51358] {\n  cursor: pointer;\n  background: #ebeef3;\n  border-radius: 10px;\n}\n.card .bar[data-v-5cf51358] {\n    width: 100%;\n    height: 10px;\n    border-radius: 10px 10px 0 0;\n}\n.card .card-header[data-v-5cf51358] {\n    border-radius: 10px 10px 0 0;\n    background-color: #f7f7f7;\n    padding: 1rem;\n}\n.currFields[data-v-5cf51358] {\n  float: left;\n  width: 33.3%;\n  padding: 10px;\n  border: 2px solid #f7f7f7;\n  background-color: #e4e5e9;\n}\n.labelBody[data-v-5cf51358] {\n  overflow: scroll;\n  background-color: #f7f7f7;\n  padding: 10px 4px 10px 10px;\n  word-break: break-word;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5cf51358","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/settings/brands.vue
// module id = 1413
// module chunks = 2